import styled from 'styled-components';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
export const StyledOperationsHubOnboardingOverviewMenuButton = styled.div.withConfig({
  displayName: "StyledOperationsHubOnboardingOverviewMenuButton",
  componentId: "sc-1gsfi0p-0"
})(["display:flex;flex-basis:48%;max-width:100%;cursor:pointer;border-radius:3px;padding:10px;border:1px solid transparent;box-shadow:0 0 5px transparent;align-self:center;:hover{border:1px solid ", ";box-shadow:0 0 5px ", ";}"], ({
  theme
}) => theme.color['do-not-use-calypso-dark'], ({
  theme
}) => theme.color['do-not-use-calypso-medium']);

/* @bend-expect no-styled-foundations-components */
export const StyledOperationsHubOnboardingOverviewMenuButtonUIIllustration = styled(Illustration).withConfig({
  displayName: "StyledOperationsHubOnboardingOverviewMenuButton__StyledOperationsHubOnboardingOverviewMenuButtonUIIllustration",
  componentId: "sc-1gsfi0p-1"
})(["margin-right:10px;"]);
export const StyledOperationsHubOnboardingOverviewMenuButtonTitleDiv = styled.div.withConfig({
  displayName: "StyledOperationsHubOnboardingOverviewMenuButton__StyledOperationsHubOnboardingOverviewMenuButtonTitleDiv",
  componentId: "sc-1gsfi0p-2"
})(["font-size:14px;font-weight:600;line-height:24px;align-items:center;"]);